import React, { useEffect, useState } from 'react';
import client, { apiError } from '../api/client';

const DEFAULT_TOPICS = {
  people: ['Leading a team', 'Conflict management', 'Stakeholder engagement', 'Virtual teams', 'Empowerment'],
  process: ['Life-cycle selection', 'Scope & backlog', 'Schedule', 'Cost & earned value', 'Risk & issues', 'Quality', 'Procurement'],
  'business-environment': ['Strategic alignment', 'Benefits & value', 'Compliance', 'Org change', 'ESG & sustainability', 'AI & technology'],
};

const DOMAIN_LABEL = {
  people: 'People (33%)',
  process: 'Process (41%)',
  'business-environment': 'Business Environment (26%)',
};

export default function Progress() {
  const [saved, setSaved] = useState({}); // key `${domain}::${topic}` -> confidence
  const [error, setError] = useState('');
  const [savingKey, setSavingKey] = useState('');

  const load = async () => {
    try {
      const { data } = await client.get('/progress');
      const map = {};
      data.progress.forEach((p) => { map[`${p.domain}::${p.topic}`] = p.confidence; });
      setSaved(map);
    } catch (err) {
      setError(apiError(err));
    }
  };

  useEffect(() => { load(); }, []);

  const setConfidence = async (domain, topic, confidence) => {
    const key = `${domain}::${topic}`;
    setSaved((s) => ({ ...s, [key]: confidence }));
    setSavingKey(key);
    try {
      await client.put('/progress', { domain, topic, confidence });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setSavingKey('');
    }
  };

  return (
    <div className="container" style={{ marginTop: 28, marginBottom: 40 }}>
      <h1>Your progress</h1>
      <p className="muted small">Rate your confidence per topic (0–100). Focus your final weeks on the low bars.</p>
      {error && <div className="alert alert-error" style={{ margin: '12px 0' }}>{error}</div>}

      <div className="stack" style={{ marginTop: 18 }}>
        {Object.keys(DEFAULT_TOPICS).map((domain) => (
          <div className="card" key={domain}>
            <h3>{DOMAIN_LABEL[domain]}</h3>
            <div className="stack" style={{ marginTop: 8 }}>
              {DEFAULT_TOPICS[domain].map((topic) => {
                const key = `${domain}::${topic}`;
                const val = saved[key] ?? 0;
                return (
                  <div key={topic} className="weight-row" style={{ gridTemplateColumns: '190px 1fr 48px' }}>
                    <div className="small">{topic}</div>
                    <input
                      type="range" min="0" max="100" value={val}
                      onChange={(e) => setConfidence(domain, topic, parseInt(e.target.value, 10))}
                      style={{ padding: 0 }}
                    />
                    <div className="small" style={{ fontWeight: 700, textAlign: 'right' }}>
                      {val}{savingKey === key ? '…' : ''}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
